import { FinancialData, Util } from '@finley-technologies/finley-types';

import { colors, transparency } from 'packages/common-frontend/colors';
import { PortfolioChartConfig } from 'packages/portfolio/ui/shared/portfolioChartUtils';

type LineItemConfig = {
  chartType: 'bar';
  field: string;
  label: string;
  format: 'currency';
  color: string;
  activeColor: string;
  stackId: string;
};

const addTransparencyToColor = (color: string) => `${color}${transparency[50]}`;

const generateLineItemConfig = (
  lineItems: string[],
  lineItemsDescriptions: string[],
): PortfolioChartConfig<
  FinancialData.FinancialStatementsChartDataType['reportingDate']
> => {
  const chartColorsList = Object.entries(colors.chart).map((color) => color[1]);
  return lineItems.reduce((acc, lineItem, idx) => {
    return {
      ...acc,
      [lineItem]: {
        chartType: 'bar',
        field: lineItem,
        label: lineItemsDescriptions[idx],
        format: 'currency',
        color: addTransparencyToColor(chartColorsList[idx]),
        activeColor: chartColorsList[idx],
        stackId: 'end of period date',
      },
    };
  }, {} as Record<Util.FullDateStr, LineItemConfig>);
};

export const generateFinancialStatementsChartConfig = ({
  lineItemsDescriptions,
  lineItems,
}: {
  lineItemsDescriptions: string[];
  lineItems: string[];
}) => {
  const chartConfig = generateLineItemConfig(lineItems, lineItemsDescriptions);

  return chartConfig;
};
